import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatastoreService } from './datastore.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {

  constructor(private datastoreService: DatastoreService, private router: Router, private activatedRoute: ActivatedRoute) { }

  routeToService() {
    const routes = this.router.config;
    const serviceId = this.datastoreService.getServiceId();
    if (serviceId) {
      const routeTo = routes.filter(x => x.data?.serviceId === serviceId)[0].path;
      this.router.navigate([`/${routeTo}`]);
    } else {
      this.router.navigate(['/solihullhwrcconnect']);
    }
  }

  routeToPage(routeName, params?: {[key: string]: any}) {
    const service = this.router.routerState.snapshot.root.children[0].url[0].path
    this.router.navigate([`/${service}/${routeName}`], { queryParams: params });
  }

  restartJourney() {
    const service = this.router.routerState.snapshot.root.children[0].url[0].path
    this.router.navigate([`/${service}`]);
  }

}
